import { render, staticRenderFns } from "./SelectInspector.vue?vue&type=template&id=6355a59a&scoped=true"
import script from "./SelectInspector.vue?vue&type=script&lang=ts"
export * from "./SelectInspector.vue?vue&type=script&lang=ts"
import style0 from "./SelectInspector.vue?vue&type=style&index=0&id=6355a59a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6355a59a",
  null
  
)

export default component.exports